import { Stack, type StackProps, chipClasses, iconClasses, styled } from "@mui/material";

const PREFIX = "CalendarContainer";

export const classes = {
  root: `${PREFIX}-root`,
  cell: `${PREFIX}-cell`,
  cellDisabled: `${PREFIX}-cellDisabled`,
  cellDate: `${PREFIX}-cellDate`,
  event: `${PREFIX}-event`,
  eventStart: `${PREFIX}-eventStart`,
  eventDuring: `${PREFIX}-eventDuring`,
  eventEnd: `${PREFIX}-eventEnd`,
  eventViewMore: `${PREFIX}-eventViewMore`,
  eventOverflow: `${PREFIX}-eventOverflow`,
};

export interface ICalendarContainerProps extends StackProps {
  cellPerLine: number;
  lineCount: number;
}

export const CalendarContainer = styled(Stack)<ICalendarContainerProps>(({ theme, cellPerLine, lineCount }) => {
  const width = `${100 / cellPerLine}%`;
  const height = `${100 / lineCount}%`;

  return {
    [`&.${classes.root}`]: {
      flex: "auto",
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      [`& .${classes.cell}`]: {
        position: "relative",
        overflow: "hidden",
        flex: `0 0 ${width}`,
        alignItems: "center",
        gap: theme.spacing(0.5),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        maxWidth: width,
        height: height,
        maxHeight: height,
        borderBottom: "1px solid #DDD",
        borderRight: "1px solid #DDD",
        [`&:nth-of-type(-n + ${cellPerLine})`]: {
          borderTop: "1px solid #DDD",
        },
        [`&:nth-of-type(${cellPerLine}n)`]: {
          borderRight: "none",
        },
        [`&.${classes.cellDisabled}`]: {
          color: theme.palette.disabled.main,
        },
        [`& .${classes.cellDate}:hover`]: {
          cursor: "pointer",
        },
        [`& .${classes.event}`]: {
          flex: "0 0 auto",
          borderRadius: "4px",
          justifyContent: "start",
          marginLeft: theme.spacing(1),
          marginRight: theme.spacing(1),
          [`&.${classes.eventStart}`]: {
            position: "relative",
            "&::after": {
              position: "absolute",
              top: 8,
              right: theme.spacing(-1),
              content: "''",
              backgroundColor: "inherit",
              height: 8,
              width: theme.spacing(1),
            },
          },
          [`&.${classes.eventDuring}`]: {
            marginRight: 0,
            marginLeft: 0,
            borderRadius: 0,
          },
          [`&.${classes.eventEnd}`]: {
            marginLeft: 0,
            borderRadius: "0px 4px 4px 0px",
          },
          [`&.${classes.eventDuring}, &.${classes.eventEnd}`]: {
            height: 8,
            marginTop: 8,
            marginBottom: 8,
            [`& .${chipClasses.label}`]: {
              display: "none",
            },
          },
          [`&.${classes.eventViewMore}`]: {
            position: "absolute",
            width: `calc(100% - ${theme.spacing(2)})`,
          },
          [`&.${classes.eventOverflow}`]: {
            visibility: "hidden",
          },
          [`& .${iconClasses.root}`]: {
            fontSize: 16,
          },
        },
      },
    },
  };
});
